<template>
    <v-card>
        <slot name="card-header"></slot>
        <v-card-text>
            <slot name="header"></slot>

            <custom-jodit-editor v-model="content" :config="editorConfig"
                @input="handleEditorInput"></custom-jodit-editor>

            <slot name="bottom-content"></slot>

            <slot name="bottom-buttons"></slot>
        </v-card-text>
    </v-card>
</template>

<script>
    import CustomJoditEditor from "@/components/editors/CustomJoditEditor.vue";

    export default {
        name: "editor-card",
        components: {
            CustomJoditEditor,
        },
        props: {
            value: String,
        },
        data() {
            return {
                content: this.value,
                editorConfig: {
                    readonly: false,
                    height: 500,
                    buttons: [
                        'bold', 'italic', 'underline', 'strikethrough',
                        '|', 'superscript', 'subscript',
                        '|', 'align', 'ul', 'ol',
                        '|', 'font', 'fontsize', 'brush',
                        '|', 'link', 'image',
                        'table', 'tableDestroy', '|',
                        '|', 'undo', 'redo',
                        '|', 'preview'
                    ],
                    uploader: {
                        insertImageAsBase64URI: true, // 이미지를 Base64로 삽입
                    },
                    defaultActionOnPaste: 'insert_clear_html',
                    allowResizeX: true,
                    allowResizeY: true,
                    useImageEditor: true,
                    toolbarAdaptive: false,
                    createAttributes: {
                        // table: {
                        //     style: 'border:1px solid;border-collapse:collapse;width: 100%;',
                        // },
                        // tr: {
                        //     style: ' border: 1px solid;',
                        // },
                        // td: {
                        //     style: ' border: 1px solid;',
                        // },
                    },
                },
            }
        },
        methods: {
            handleEditorInput(newValue) {
                this.content = newValue;
                this.$emit("update-content", newValue);
            },
        },
        watch: {
            value(newValue) {
                this.content = newValue;
            },
        },
    }
</script>

<style scoped></style>